import { useState, useEffect } from "react";

// ─────────────────────────────────────────────────────────────────────────────
// useLocalStorage
// Hook générique : comme useState mais persisté dans localStorage.
// Usage identique à useState :
//   const [value, setValue] = useLocalStorage("cle", valeurInitiale);
// ─────────────────────────────────────────────────────────────────────────────

function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.warn(`useLocalStorage: erreur lecture "${key}"`, error);
      return initialValue;
    }
  });

  const setValue = (value) => {
    try {
      // Supporte les fonctions updater comme setState
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      if (valueToStore === null || valueToStore === undefined) {
        window.localStorage.removeItem(key);
      } else {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      console.warn(`useLocalStorage: erreur écriture "${key}"`, error);
    }
  };

  // Sync entre onglets
  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === key && e.newValue !== null) {
        try {
          setStoredValue(JSON.parse(e.newValue));
        } catch {}
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, [key]);

  return [storedValue, setValue];
}

export default useLocalStorage;